import type { CampaignReferral } from './campaign-resolve.types';

const PROD_API_URL =
  'https://dxpuw6f7o9.execute-api.eu-central-1.amazonaws.com/dev/';

// Mirrors google-login.ts: dev server proxies /api, everything else hits the
// configured API (or prod fallback).
function getBaseUrl(): string {
  const isDevServer =
    import.meta.env.DEV && window.location.protocol === 'http:';
  if (isDevServer) return '';
  return import.meta.env.VITE_API_URL ?? PROD_API_URL;
}

/**
 * Resolve a campaign ref (the webapp `?ref=` code) to its registered Overwolf
 * affiliation id, so a webapp-sourced install can be stamped with the same
 * campaign the visitor arrived through.
 *
 * Returns null when the ref matches no campaign or the request fails — callers
 * fall back to the default install link rather than guessing.
 */
export async function resolveCampaignReferral(
  ref: string,
): Promise<CampaignReferral | null> {
  try {
    const base = getBaseUrl().replace(/\/$/, '');
    const response = await fetch(
      `${base}/api/v1/campaigns/resolve?ref=${encodeURIComponent(ref)}`,
    );
    if (!response.ok) return null;
    return (await response.json()) as CampaignReferral;
  } catch {
    return null;
  }
}
